import React from "react";
import { Button } from 'react-bootstrap';

export default function AssessmentSubmit(props) {
    return (
        <React.Fragment>
            <div className="row  mb-3 p-5 text-center">
                <p>
                {props.MODE === 'create'
                    ? "Your Assessment was saved."
                    : "Your Assessment was updated."
                }
                </p>
                <p>
                    <Button
                        size="md"
                        href={process.env.REACT_APP_DS_HOME}
                        >
                        Home
                    </Button>
                </p>
            </div>
        </React.Fragment>
    )
}